import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid h-full w-full grid-cols-1 gap-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex h-full flex-col justify-center rounded-l-lg bg-gray-50 px-2 py-4" }
const _hoisted_5 = { class: "flex flex-col items-start p-3" }
const _hoisted_6 = { class: "font-semibold text-gray-700" }
const _hoisted_7 = { class: "text-left text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: $setup.showForm,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showForm) = $event)),
    title: _ctx.$t('connectFlow.componentSelector')
  }, {
    default: _withCtx(() => [
      ($setup.rules !== undefined)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.NodeType, (type) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `nodeButton${type}`
                }, [
                  (
                            $setup.rules.typesChildren.includes(type) &&
                            (type !== $setup.NodeType.CONNECT_FLOW_CUSTOM || $setup.hasConnectFlowCustomOptions)
                        )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        type: "button",
                        onClick: ($event: any) => ($setup.setUpNode(type)),
                        class: "flex cursor-pointer items-center rounded bg-gray-50 shadow ring-1 ring-gray-300 hover:bg-white focus:ring-2 focus:ring-opacity-50"
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getNodeComponent(type)), { class: "text-secondary h-8 w-8" }))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`connectFlow.node.${type}.title`)), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`connectFlow.node.${type}.helpText`)), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_3))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title"]))
}